import styled from 'styled-components';

export const CellWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 4px;
`;
